import * as types from './constants';

export const setProductsInfo = payload => dispatch => {
  return dispatch({
    type: types.SET_PRODUCT_INFO,
    payload
  });
};
